import { render, staticRenderFns } from "./ComposantModaleAlert.vue?vue&type=template&id=b9990998&scoped=true"
import script from "./ComposantModaleAlert.vue?vue&type=script&lang=js"
export * from "./ComposantModaleAlert.vue?vue&type=script&lang=js"
import style0 from "./ComposantModaleAlert.vue?vue&type=style&index=0&id=b9990998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9990998",
  null
  
)

export default component.exports